import React, { useState } from 'react'
import Dropzone from "react-dropzone";
import validator from "validator";
import { Alert } from '@mui/material';

const Register = ({setPageType}) => {
  const initialRegisterValues = {
  firstName: "",
  lastName: "",
  email: "",
  password: "",
  location: "",
  occupation: "",
  picture: "",
};
const [registerValues,setRegisterValues]=useState(initialRegisterValues)
const [isLoading,setIsLoading]=useState(false)
const [success,setSuccess]=useState({status:false,msg:""})
const [validateError,setValidateError]=useState({
  errorStatus:false,
  errorMsg:"",
})

const handleChange=(e)=>{
  const {name, value}=e.target
  setRegisterValues((prevValues)=>{
    return {
      ...prevValues,
      [name]:value
    }
  })
}

const handleSubmit=async(e)=>{
  const formData=new FormData()
  e.preventDefault()
  const {firstName,lastName,occupation,email,password,picture,location}=registerValues
  if(firstName && lastName && occupation && email && password && location && picture && validator.isEmail(email)){
    setIsLoading(true)
    //in order to upload image to image to backend we to send for data using FormData()
   formData.append("firstName",firstName)
   formData.append("lastName",lastName)
   formData.append("occupation",occupation)
   formData.append("email",email)
   formData.append("password",password)
   formData.append("location",location)
   formData.append("picture",picture)
   formData.append("picturePath",picture.name)

    const savedUserResponse = await fetch(
      "https://thoughtful-erin-oyster.cyclic.app/auth/register",
      {
        method: "POST",
        //headers: { "Content-Type": "application/json" },
        body: formData
      }
    );
    const savedUser = await savedUserResponse.json();
    setIsLoading(false)
    setValidateError({errorStatus:false,errorMsg:""})
    setRegisterValues(initialRegisterValues)
    if(savedUser){
      setSuccess({status:true, msg:"User SuccessFully Registered, Login to your Account"})
      setTimeout(()=>{
        setPageType("login")
      },4000)
    }
  }
  else{
      setValidateError({
        errorStatus:true,
        errorMsg:"All fields are required or either you entered a invalid email"
      })
  }
}

  return (
    <div>
        <form onSubmit={handleSubmit} className="w-full grid grid-cols-4 bg-white dark:bg-gray-900 p-4 rounded-lg gap-3">
          <h1 className="col-span-full w-full text-xs sm:text-sm font-semibold dark:text-gray-100">Welcome to SocioConnect, Build your Connect</h1>
          <input onChange={handleChange} className="dark:bg-[#3D3B3B] dark:text-gray-400 rounded-md col-span-2 w-full p-2  text-xs  border-gray-400 border-2" name='firstName' type="text" placeholder="First Name" />
          <input onChange={handleChange} className="dark:bg-[#3D3B3B] dark:text-gray-400 rounded-md col-span-2 w-full p-2  text-xs border-gray-400 border-2" name='lastName' type="text" placeholder="Last Name" />
          <input onChange={handleChange} className="dark:bg-[#3D3B3B] dark:text-gray-400 rounded-md col-span-2 sm:col-span-full w-full p-2 text-xs border-gray-400 border-2" type="text" name='location' placeholder="Location" />
          <input onChange={handleChange} className="dark:bg-[#3D3B3B] dark:text-gray-400 rounded-md col-span-2 sm:col-span-full w-full p-2  text-xs border-gray-400 border-2" type="text" name='occupation' placeholder="Occupation" />
          <Dropzone multiple={false} onDrop={(acceptedFiles) => setRegisterValues(({...registerValues,picture:acceptedFiles[0]}))}>
            {({ getRootProps, getInputProps }) => (
              <section className="col-span-full w-full border-2 border-gray-400 p-4 rounded-md cursor-pointer">
                <div
                  className="border-2 border-rose-700 border-dashed flex justify-center items-center p-2 "
                  {...getRootProps()}
                >
                  <input {...getInputProps()} />
                  {!registerValues?.picture?(
                    <p className="text-sm dark:text-gray-100">Add your Picture Here</p>
                  ):(
                    <p className="text-sm dark:text-gray-100">{registerValues.picture.name}</p>
                  )}
                </div>
              </section>
            )}
          </Dropzone>
          <input onChange={handleChange} className="dark:bg-[#3D3B3B] dark:text-gray-400 col-span-2 w-full rounded-md p-2  text-xs border-gray-400 border-2" type="email" name="email" placeholder="Email" />
          <input onChange={handleChange} className="dark:bg-[#3D3B3B] dark:text-gray-400 col-span-2 w-full rounded-md p-2  text-xs border-gray-400 border-2" type="password" name="password" placeholder="Password" />
          <input onChange={handleChange} className="cursor-pointer col-span-full w-full bg-rose-700 rounded-md p-2 text-sm text-white" type="submit" value={isLoading?("Register..."):("Register")} />
          <h3 className=" col-span-full cursor-pointer text-xs underline decoration-solid text-rose-700"
          onClick={()=>setPageType("login")}>Already have an Account? Login here</h3>
          {validateError.errorStatus && (<Alert sx={{gridColumn:"1/-1",fontSize:"10px", marginTop:"5px"}} severity="error">{validateError.errorMsg}</Alert>)}
        </form>
        {success.status && <div className='mt-2'>
                        <Alert severity='success' sx={{fontSize:"12px"}}>{success.msg}</Alert>
                   </div>
          }
    </div>
  )
}

export default Register